import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createVNode as _createVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = ["loading", "type"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_uploadFileTable = _resolveComponent("uploadFileTable")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.IsShwoOpenTick && _ctx.typebtn === 'primary')
      ? (_openBlock(), _createBlock(_component_a_button, {
          key: 0,
          loading: _ctx.loading,
          disabled: false,
          type: _ctx.typebtn,
          onClick: _ctx.openTicket
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.btnName), 1)
          ]),
          _: 1
        }, 8, ["loading", "type", "onClick"]))
      : _createCommentVNode("", true),
    (_ctx.IsShwoOpenTick && _ctx.typebtn === 'text')
      ? (_openBlock(), _createElementBlock("a", {
          key: 1,
          style: { color: '#2f7bff' },
          href: "javascript:void(0)",
          loading: _ctx.loading,
          class: "theme-color",
          type: _ctx.typebtn,
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openTicket && _ctx.openTicket(...args)))
        }, _toDisplayString(_ctx.btnName), 9, _hoisted_1))
      : _createCommentVNode("", true),
    _createVNode(_component_a_modal, {
      confirmLoading: _ctx.okLoading,
      centered: true,
      keyboard: false,
      "mask-closable": false,
      visible: _ctx.visible,
      "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.visible) = $event)),
      title: "完成开票",
      "ok-text": "确认",
      "cancel-text": "取消",
      onOk: _ctx.ok,
      onCancel: _ctx.onCancel,
      width: "600",
      loading: true
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_form, {
          layout: "vertical",
          ref: "formRef"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_uploadFileTable, {
              "allow-edit": true,
              value: _ctx.attachList,
              "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.attachList) = $event)),
              "biz-id": _ctx.id,
              "biz-type": _ctx.attachBizType
            }, null, 8, ["value", "biz-id", "biz-type"])
          ]),
          _: 1
        }, 512)
      ]),
      _: 1
    }, 8, ["confirmLoading", "visible", "onOk", "onCancel"])
  ], 64))
}